import io from "socket.io-client";
import Config from "../config/config";

export const socket = io(Config.Back_URL);
